export default "__VITE_ASSET__CzyH9TMF__"